import usePrivateAxios from "@/common/api/usePrivateAxios";
import { AxiosError } from "axios";
import { useMutation } from "@tanstack/react-query";
import { EstablishmentEnableValidationSchema } from "../schemas/enableDisableEstablishment.schema";

interface UseEnableEstablishmentProps {
  establishmentId?: string;
  onSuccess?: () => void;
  onError?: (error: AxiosError) => void;
}

const useEnableEstablishment = ({ establishmentId, onSuccess, onError }: UseEnableEstablishmentProps) => {
  const privateAxios = usePrivateAxios();
  return useMutation<void, AxiosError, EstablishmentEnableValidationSchema>({
    mutationKey: ['enableEstablishment', establishmentId],
    mutationFn: (data) => privateAxios.put(`/establishment/companies/${establishmentId}/reenable`, {
      company: {
        reason: data.enable_reason,
      },
    }),
    onSuccess,
    onError,
  });
};

export default useEnableEstablishment;
